<template>
  <div class="select is-fullwidth">
    <select name="" id="" @change.prevent="isEmpty(id) ? selectGroup() : () => {}" v-model="selected_group_id" :disabled="!isEmpty(id)">
      <option value="">Pilih Kelas</option>
      <option v-for="(group, key) in groups" :key="key" :value="group.id">{{ group.name }} ({{ group.description }})</option>
    </select>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    onSelect: {
      type: Function,
      default: () => {}
    },
    id: {
      default: null
    }
  },

  computed: {
    ...mapState({
      groups: state => state.groups.all
    }),
  },

  mounted() {
    this.$store.dispatch('groups/getAllGroups');

    if (!this.isEmpty(this.id)) {
      this.selected_group_id = this.id;

      this.selectGroup();
    }
  },

  data() {
    return {
      selected_group_id: !this.isEmpty(this.id) ? _.clone(this.id) : ''
    }
  },

  methods: {
    selectGroup() {
      const group = collect(this.groups).where('id', '==', this.selected_group_id).first();
      this.onSelect(group)
    }
  }
}
</script>
